export function calculatePriceWithTax(taxRate: number, price: number) {
  const totalPrice = price + price * taxRate
  return totalPrice
}
